







































import Vue, { VueConstructor } from 'vue';
import PageTitle from '@/common/components/PageTitle.vue';
import { SearchParams } from '../../../models/api-client';
import { RulesOperatorHelper } from '../../../common/utils/RulesOperatorHelper';
import { ToastMessage } from '@/plugins/toast/models/message';
import lang from '../../../common/lang/de';

export default (Vue as VueConstructor<Vue & {
  $refs: {},
}>).extend({
  name: 'SearchCustomer',
  components: {
    PageTitle,
  },
  data() {
    return {
      search: '' as any,
      rules: {
        maxLength: (value: any) => (value.trim().length <= 100) || RulesOperatorHelper.maxLength(100),
      },
    };
  },
  methods: {
    searchForName() {
      const searchParams = {} as SearchParams;
      this.search = this.search.trim();
      searchParams.wordList = this.search.split(' ');

      this.$emit('inputData', searchParams);
    },
    searchForTelephone() {
      const searchParams = {} as SearchParams;
      const number = this.search.replace(/[^0-9]/gi, '');
      const re = /^\d+$/;

      if (re.test(String(number))) {
        searchParams.phoneNumber = number;
        this.$emit('inputData', searchParams);
      } else {
        const toast = {} as ToastMessage;
        toast.header = lang.global.error.unerwarteter.header;
        toast.message = lang.global.error.unerwarteter.message;
        this.$toast.error(toast);
      }
    },
    searchForCustomerNumber() {
      const searchParams = {} as SearchParams;
      const number = this.search.replace(/[^0-9]/gi, '');
      const re: RegExp = /^\d+$/;

      if (re.test(String(number))) {
        searchParams.customerNumber = number;
        this.$emit('inputData', searchParams);
      } else {
        const toast = {} as ToastMessage;
        toast.header = lang.global.error.unerwarteter.header;
        toast.message = lang.global.error.unerwarteter.message;
        this.$toast.error(toast);
      }
    },
  },
});
